import { ojs, app, each, v } from "modular-openscriptjs";
import { gc, uc, pc, dc } from "../declarations";
import { either, sendEvent, store } from "../helpers";
import Navigation from "./Navigation";
import Logo from "./Blocks/Logo";
import Link from "./Blocks/Link";
import SearchIconBtn from "./Blocks/SearchIconBtn";
import ProfilePic from "./ProfilePic";
import BackButton from "./Blocks/BackButton";
import SolidIcon from "./Blocks/SolidIcon";
import BsIcon from "./Blocks/BsIcon";
import SearchBar from "./Blocks/SearchBar";

const h = app("h");
const $e = app("$e");

ojs(
	Logo,
	Link,
	SearchIconBtn,
	ProfilePic,
	BackButton,
	SolidIcon,
	BsIcon,
	SearchBar
);

export default class TopNav extends Navigation {
	name = "TopNav";


	collapseSideNav() {
		pc.sideNavCollapsed.value =
			!pc.sideNavCollapsed.value;

		store(
			"sideNavCollapse",
			pc.sideNavCollapsed?.value ?? false
		);
	}

	renderNotificationButton() {
		return h.button(
			{
				class: `btn btn-outline-secondary border-transparent me-1 nav-auth-btn position-relative d-flex align-items-center justify-content-center p-2`,
				onclick: h.func("app('router').to", "user.notifications"),
				title: "Notifications"
			},
			h.i({ class: "bi bi-bell" }),
			v(dc.notificationsCount, (c) => {
				if (c.value?.unread > 0) {
					return h.span(
						{ 
							class: "position-absolute top-25 start-75 translate-middle badge rounded-pill bg-danger",
							style: "font-size: 0.65rem; padding: 0.25em 0.4em;"
						},
						c.value.unread > 99 ? "99+" : c.value.unread,
						h.span({ class: "visually-hidden" }, "unread notifications")
					);
				}
				return h.empty();
			})
		);
	}

	render(items, ...args) {
		return h.header(
			{
				id: "header",
				class: `fixed-top d-block header-padding-top ${
					gc.auth.value
						? "header-auth-mobile header-primary"
						: "bg-white shadow-sm pt-3"
				}`,
			},
			h.div(
				{ class: "px-3" },
				h.div(
					{ class: "row gx-0 gx-lg-3", style: "max-height: 70px;" },
					h.div(
						{
							class: "col-2 col-md-3 d-grid align-items-center header-left",
						},
						h.div(
							{
								class: "d-flex align-items-center gap-3",
							},
							either(gc.auth.value, () =>
								h.div(
									{
										class: "d-flex align-items-center gap-2",
									},
									h.BackButton({
										class: `d-md-none ${
											gc.auth.value
												? "nav-auth-btn"
												: "btn-lg ms-reset"
										}`,
									}),
									h.button(
										{
											class: "btn btn-icon d-none d-lg-flex align-items-center justify-content-center",
											style: "width: 40px; height: 40px; border-radius: 50%; border: none; background: transparent;",
											onclick: this.method("collapseSideNav"),
										},
										v(pc.sideNavCollapsed, (c) =>
											either(
												c.value,
												h.BsIcon("chevron-right"),
												h.BsIcon("chevron-left")
											)
										)
									)
								)
							),
							h.div({ class: "logo d-none d-md-block" }, h.Logo())
						)
					),

					h.div(
						{
							class: "d-none d-lg-grid col-lg-6 align-items-center header-middle",
						},
						h.div(
							{ class: "px-md-3" },
							// either(gc.auth.value, () => h.SearchBar())
						)
					),

					h.div(
						{
							class: "col-10 d-flex d-md-none align-items-center justify-content-end mobile-search gap-2",
						},
						either(gc.auth.value, () => this.renderNotificationButton())
					),

					h.div(
						{
							class: "d-none d-md-grid col-md-3 align-items-center header-right",
						},
						h.div(
							h.div(
								{
									class: "d-flex align-items-center justify-content-end gap-md-3",
								},
								v(gc.auth, (auth) =>
									either(
										auth.value,
										h.div(
											{
												class: "d-flex gap-2 align-items-center",
											},
											this.renderNotificationButton(),
											h.a(
												{
													role: "button",
													class: "btn btn-outline-secondary border-transparent me-2 nav-auth-btn",
													onclick: h.func("app('router').to", "company.select"),
													title: "Switch Company"
												},
												h.i({ class: "bi bi-arrow-left-right" })
											),
											h.a(
												{
													role: "button",
													id: "offcanvas-open-profile-btn",
													data_bs_toggle: "offcanvas",
													data_bs_target:
														"#offcanvasAccount",
													aria_controls:
														"offcanvasAccount",
													class: `btn btn-outline-primary border-transparent me-reset ${
														gc.auth.value
															? "nav-auth-btn"
															: "btn-lg"
													}`,
												},
												h.i({
													class: "bi bi-person",
												})
											)
										),
										h.button(
											{
												class: "btn btn-primary rounded-pill fw-bold shadow-sm header-cta-btn d-flex align-items-center gap-2",
												onclick: `sendEvent('${$e.user.needs.authentication}')`,
											},
											"Start Riding"
										)
									)
								)
							)
						)
					)
				)
			),
			...args
		);
	}
}
